// Platform Audit Log — the SuperAdmin view of GET /audit/.
//
// This was a 294-line bespoke implementation of the same screen every other role
// already had. It had no paging: a hard 500-row cap per window, honestly
// labelled but with no way to reach anything older than that, on the one surface
// whose entire job is looking things up after the fact. It also had no CSV
// export, no action filter and no project filter — all of which the shared
// component has had for a while.
//
// Two implementations of one screen is how they drift, and this one was the
// weaker of the two on every axis. The shared table decides SCOPE server-side
// from the caller's role, so a superadmin automatically sees every company
// without this page having to ask for it — which is also why there is no scope
// prop to get wrong here.
import PageHeader from "@/components/dashboard/PageHeader";
import AuditLogTable from "@/components/dashboard/AuditLogTable";

export default function AuditLogPage() {
  return (
    <>
      <PageHeader
        title="Audit Log"
        subtitle="Every recorded action across every tenant on the platform."
      />
      <AuditLogTable
        title="Platform activity"
        subtitle="All companies. Filter by actor, action, target or date, or export the current view as CSV."
      />
    </>
  );
}
